import type { CategoryAlias } from "@/types/directory";
import type { AdminCategoryAlias } from "@/types/admin";

/**
 * Demo category aliases — used ONLY when no API URL is configured (preview).
 *
 * These hand-map a few A–Z index category names onto the curated branded
 * category pages that ship in src/mocks/categories.ts, mirroring what an admin
 * would set up from the console in production.
 */
export const categoryAliases: CategoryAlias[] = [
  { azName: "Advocates & Lawyers",                            categorySlug: "legal-services" },
  { azName: "Jewellery Dealers",                              categorySlug: "retail" },
  { azName: "Dentists & Dental Clinics",                      categorySlug: "healthcare" },
  { azName: "Pharmacies & Medical Shops",                     categorySlug: "healthcare" },
  { azName: "Coffee Shops & Cafés",                           categorySlug: "restaurants" },
  { azName: "Bakery & Confectionery",                         categorySlug: "restaurants" },
  { azName: "IT & Software Companies",                        categorySlug: "information-technology" },
  { azName: "Real Estate Agents & Property Consultants",      categorySlug: "real-estate" },
  { azName: "Banquet Halls & Wedding Venues",                 categorySlug: "weddings" },
  { azName: "Taxi Services",                                  categorySlug: "travel" },
];

/** Admin view of the demo aliases (with ids + resolved target name). */
export const adminCategoryAliases: AdminCategoryAlias[] = categoryAliases.map((alias, index) => ({
  id: index + 1,
  azName: alias.azName,
  categorySlug: alias.categorySlug,
  categoryName: null,
  isActive: true,
}));